import Vue from "vue";
import VueRouter from "vue-router";
import * as constants from "./constants";

const axios = require('axios').default;

// listener to popstate changes
window.popStateDetected = false
window.addEventListener('popstate', () => {
    window.popStateDetected = true
})

/**
 * Class VueSearchRouter
 */
export default class VueSearchRouter {

    /**
     * Constructor
     */
    constructor() {
        Vue.use(VueRouter);

        this.router = new VueRouter({
            mode: 'history'
        });

        this.listener();
    }

    /**
     * route update listener
     * Rebuild filters when history button (backward and forward browser buttons) are clicked
     */
    listener() {
        this.router.beforeEach((to, from, next) => {
            const isForwardBackwardButton = window.popStateDetected
            window.popStateDetected = false
            if (true === isForwardBackwardButton) {
                axios({
                    method: 'post',
                    url: '/public/api/generate-filters-by-url',
                    data: {
                        url: to.path
                    }
                }).then((response) => {
                    this.context.commit('updateRequest', constants.REQUEST_HOUSES);
                    this.context.commit('updateHouseCountExpected', undefined);
                    this.context.commit('updateFilters', response.data.data[0]);
                });
            }
            next();
        })
    }

    /**
     * Initialize.
     * Load context from vue-search-base
     *
     * @param {object} context
     */
    initialize(context) {
        if ('undefined' === typeof this.context) {
            this.context = context;
        }
    }

    /**
     * Update Url
     *
     * @param {string} url
     */
    async update(url) {
        if (this.router.currentRoute.path !== url) {
            await  this.router.push(url);
        }
    }
}
